import { Grid, useEventCallback } from '@mui/material';
import { memo, useEffect, useRef } from 'react';
import { SectionVM } from 'civil-status/view-models/step-form';
import { FormControl } from '@mui/material';
import { RadioGroup } from '@mui/material';
import { FormControlLabel } from '@mui/material';
import { Radio } from '@mui/material';
import { CodeTypeAct } from 'civil-status/constants/code-type-act';

interface RadioGroupOptionsProps {
  disabled?: boolean;
  values?: SectionVM;
  onChanges: (values: SectionVM) => void;
  isAtcoFa?: boolean;
  initialValues?: SectionVM;
}

const RadioGroupOptionsComponent = ({
  disabled = false,
  values,
  onChanges,
  isAtcoFa = false,
}: RadioGroupOptionsProps): React.ReactElement => {
  const initialValueRegister = useRef<string | undefined>();

  useEffect(() => {
    if (!initialValueRegister.current) {
      initialValueRegister.current = values?.actForm?.register;
    }
  }, [values?.actForm?.register]);

  const onChangeRadio = useEventCallback((typeAct?: string) => {
    onChanges({
      ...(values || {}),
      typeAct,
      // actForm:
      //   typeAct === CodeTypeAct.nessunAtto
      //     ? undefined
      //     : {
      //         register: initialValueRegister.current,
      //       },
    });
  });

  return (
    <Grid item xs={12}>
      <FormControl component="fieldset">
        <RadioGroup
          row
          aria-label="Tipo atto"
          id="typeAct"
          defaultValue={true}
          value={values?.typeAct || ''}
          onChange={(event) => onChangeRadio(event.target.value || '')}
        >
          <FormControlLabel
            value={CodeTypeAct.attoCartaceo}
            control={<Radio />}
            label="Atto cartaceo"
            disabled={disabled}
          />
          <FormControlLabel
            value={CodeTypeAct.attoDigitale}
            control={<Radio />}
            label="Atto digitale"
            disabled={disabled}
          />
          {isAtcoFa ? (
            <FormControlLabel
              value={CodeTypeAct.nessunAtto}
              control={<Radio />}
              label="Nessun atto"
              disabled={disabled}
            />
          ) : undefined}
        </RadioGroup>
      </FormControl>
    </Grid>
  );
};

RadioGroupOptionsComponent.displayName = 'Form Act Related component';

const RadioGroupOptions = memo(RadioGroupOptionsComponent);

export default RadioGroupOptions;
